import {Box} from '@mui/material';
import AurInfographic from '../../common/aur-infographic/AurInfographic';
import {useEffect, useState} from 'react';
import {AurInfographicCellProps} from '../../common/aur-infographic/types';
import {SetupInfoGraphicData} from '../../common/aur-infographic/aurInfographicData';
import {IHeaderSummaryData} from '../project-data-table/types';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';

type InfographicContainerProps = {
  headerSummary: IHeaderSummaryData;
};

const InfographicContainer = (props: InfographicContainerProps) => {
  const [infographicCellConfigs, setInfographicCellConfigs] = useState<
    AurInfographicCellProps[]
  >([]);

  const triggerProjectsAndSummary = useSelector(
    (state: RootState) => state.clientList.triggerProjectsAndSummary
  );

  useEffect(() => {
    // Prepare infographic cell configs and set here
    if (props.headerSummary) {
      setInfographicCellConfigs(
        SetupInfoGraphicData((props.headerSummary as IHeaderSummaryData) ?? '')
      );
    }
  }, [triggerProjectsAndSummary]);

  return (
    <Box>
      <AurInfographic cellConfigs={infographicCellConfigs} />
    </Box>
  );
};

export default InfographicContainer;
